import React from 'react'
import Helmet from 'react-helmet'
import { createPageTitle } from 'utils/createPageTitle'
import { Page } from 'framework7-react'
import { connect } from 'react-redux'
import { setSelectedProduct, setSelectedPivot, addToCart } from 'store/actions/cart'
import { isDesktopDevice } from 'utils/layout'
import { CartLayout, Form, DefaultHeader, Cart, PrimaryButton, Slider } from 'components'
import './ConfigProduct.scss'
import ApplicationModal from 'components/ApplicationModal/ApplicationModal'
import productService from 'services/product'
import DosageConfig from './DosageConfig/DosageCOnfig'
import Dosage from './Dosage/Dosage'
import Quantity from './Quantity/Quantity'
import ApplicationForm from './ApplicationForm/ApplicationForm'
import CenterPivot from './CenterPivot/CenterPivot'
import ApplicationQuantity from './ApplicationQuantity/ApplicationQuantity'

class ConfigProduct extends React.Component {
  constructor(props) {
    super(props)

    const dosage = props.selectedPivot
      ? props.selectedPivot.dosage || props.selectedProduct.minDosage
      : 0

    const fixedDosage = Number(dosage)?.toFixed(3)
    const initialArea = props.selectedPivot ? (Number(props.selectedPivot.area) || 0) : 0
    this.state = {
      ...props.selectedPivot,
      applicationType: (props.selectedPivot && props.selectedPivot.applicationType) || null,
      area: initialArea,
      dosage: fixedDosage,
      inputDosage: fixedDosage,
      isDesktop: isDesktopDevice(),
    }

    this.state.quantity =
      (props.selectedPivot && props.selectedPivot.quantity) ||
      this.updateQuantity(this.state).quantity

    this.isEdit = !!this.state.applicationType
    this.state.numberOfApplications = 0
    this.state.maxApplications = 0

    this.state.openModal = false
    this.state.existingApplication = ''
    this.state.newApplication = ''

    
  }

  async componentDidMount() {
    const { selectedPivot, selectedProduct } = this.props
    if (!selectedPivot || !selectedProduct) return

    try {
      const response = await productService.getProductApplicationQuantity({
        pivotId: selectedPivot.id,
        chemicalId: selectedProduct.id,
        harvest: selectedPivot.harvestId,
      })

      this.setState({
        numberOfApplications: Number(response?.data?.applications) || 0,
        maxApplications: Number(response?.data?.maxApplications) || 0,
        applicationType: selectedPivot.applicationType,
      })
    } catch (err) {
      console.error('Erro ao buscar aplicações já feitas:', err)
    }
  }

  async componentDidUpdate(prevProps) {
    const { selectedPivot, selectedProduct } = this.props

    if (
      selectedPivot &&
      selectedProduct &&
      selectedProduct.id !== prevProps.selectedProduct?.id
    ) {
      try {
        const response = await productService.getProductApplicationQuantity({
          pivotId: selectedPivot.id,
          chemicalId: selectedProduct.id,
          harvest: selectedPivot.harvestId,
        })

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          numberOfApplications: Number(response?.data?.applications) || 0,
          maxApplications: Number(response?.data?.maxApplications) || 0,
        })
      } catch (err) {
        console.error('Erro ao buscar aplicações já feitas:', err)
      }
    }
  }


  handleSubmit() {
    const { selectedProduct, selectedFarm, chemicalResale, cart, selectedPivot } = this.props
    const sendProduct = { ...selectedProduct, unitMeasure: chemicalResale.unitMeasure }
  
    if (selectedProduct.stocks && selectedProduct.stocks.length > 0) {
      sendProduct.stock = selectedProduct.stocks.find(
        h => h.farmId === selectedFarm.id && h.actual > 0,
      )
    }
  
    const productInCart = cart[selectedProduct.id]
    
  
    if (productInCart) {
      const pivotsArray = Object.values(productInCart.pivots) // 👈 transforma em array
      const existingTypes = pivotsArray.map(p => p.applicationType?.value)
      const uniqueTypes = [...new Set(existingTypes)]

      const newType = this.state.applicationType?.value
      const labelNewType = this.state.applicationType?.label
      const existingType = uniqueTypes[0]

      const label = pivotsArray.filter(
        p => p.applicationType?.value === existingType
      )
  
      // 🚨 ajuste aqui:
      const isEditingSinglePivot =
        pivotsArray.length === 1 && pivotsArray[0].id === selectedPivot.id
  
      if (!isEditingSinglePivot) {
        if (uniqueTypes.length > 0 && !uniqueTypes.includes(newType)) {
          return this.setState({
            openModal: true,
            existingApplication: label[0]?.applicationType?.label?.split(' ')[1]?.toUpperCase(),
            newApplication: labelNewType?.split(' ')[1]?.toUpperCase(),
          })
        }
      }
    }
  
    this.props.addToCart(sendProduct, this.state)
    this.$f7router.back()
  }
  

  updateQuantity({ dosage = this.state.dosage, area = this.state.area }) {
    const numDosage = Number(dosage) || 0
    const numArea = Number(area) || 0
    const quantity = numDosage && numArea ? +(numDosage * numArea).toFixed(3) : 0

    return { dosage, area, quantity, inputDosage: dosage }
  }

  verifyDosage(dosage) {
    const { selectedProduct } = this.props
    const { minDosage, maxDosage } = selectedProduct
    let finalDosage = Number(dosage).toFixed(3)

    if (finalDosage < selectedProduct.minDosage) finalDosage = minDosage.toFixed(3)

    if (selectedProduct.maxDosage && finalDosage > selectedProduct.maxDosage)
      finalDosage = maxDosage.toFixed(3)

    this.setState(this.updateQuantity({ dosage: finalDosage }))
  }

  isValidForm() {
    const { applicationType, area, numberOfApplications, maxApplications } = this.state

    const hasMaximumApplication = maxApplications > 0 && numberOfApplications >= maxApplications
    if (hasMaximumApplication) return false

    return !!applicationType && area !== ''
  }

  render() {
    const { selectedProduct, selectedPivot, chemicalResale } = this.props
    const pageTitle = createPageTitle('Configurar Produto')

  

    let areaWidth = 0

    for (let index = 0; index <= 6; index += 1) {
      if (this.state.area >= 10 ** index) areaWidth = index
    }

    return (
      <Page className="config-product-page">
        <Helmet title={pageTitle} />
        <CartLayout withCart>
          <DefaultHeader
            router={this.$f7router}
            headerTitle={
              <div className="config-product-page__header">
                <h1 className="config-product-page__header__title">{selectedProduct.name}</h1>
                <p className="config-product-page__header__days">{`Previsão de entrega: ${chemicalResale.resale.weekDaysToDeliver}`}</p>
              </div>
            }
            beforeTitle={selectedPivot.name}
            isModal={this.state.isDesktop}
          />
          <div className="config-product-page__body">
            <Form >
              <div className="config-product-page__item">
                <div className="config-product-page__item__header">
                  {selectedProduct.maxDosage ? (
                    <Dosage
                      minDosage={Number(selectedProduct.minDosage.toFixed(3))}
                      maxDosage={Number(selectedProduct.maxDosage.toFixed(3))}
                      inputDosage={this.state.inputDosage}
                      handleInputChange={newValue => this.setState({ inputDosage: newValue })}
                      handleInputBlur={value => this.verifyDosage(value)}
                      unitMeasure={chemicalResale.unitMeasure}
                    />
                  ) : (
                    <DosageConfig
                      name="Dosagem"
                      description={`${Number(selectedProduct.minDosage.toFixed(3))} ${chemicalResale.unitMeasure}`}
                      quantityTitle={`${selectedProduct.minDosage} ${chemicalResale.unitMeasure}`}
                    />
                  )}
                </div>
                {selectedProduct.maxDosage ? (
                  <Slider
                    value={this.state.dosage}
                    min={Number(selectedProduct.minDosage.toFixed(3))}
                    max={Number(selectedProduct.maxDosage.toFixed(3))}
                    step={0.001}
                    onChange={newValue => this.setState(this.updateQuantity({ dosage: newValue }))}
                  />
                ) : null}
              </div>
              <div className="config-product-page__item">
                <Quantity
                  stocks={chemicalResale.stocks}
                  unitMeasure={chemicalResale.unitMeasure}
                  quantity={this.state.quantity}
                />
              </div>
              <div className="config-product-page__item">
                <ApplicationQuantity
                  applications={this.state.numberOfApplications}
                  maxApplications={this.state.maxApplications}
                />
              </div>
              {(this.state.maxApplications === 0 ||
                (this.state.maxApplications > 0 && this.state.numberOfApplications < this.state.maxApplications)) && (
                <div className="config-product-page__item">
                  <ApplicationForm
                    handleSelectChange={applicationType =>
                      this.setState({
                        ...this.updateQuantity({ area: selectedPivot.area }),
                        applicationType,
                      })
                    }
                    applicationType={this.state.applicationType}
                  />
                </div>
              )}
              {this.state.applicationType && this.state.applicationType.value === 2 && (
                <div className="config-product-page__item">
                  <CenterPivot
                    area={this.state.area}
                    areaWidth={areaWidth}
                    handleInputChange={value => this.setState(this.updateQuantity({ area: value }))}
                  />
                </div>
              )}
              <PrimaryButton disabled={!this.isValidForm()} onClick={() => this.handleSubmit()}>
                {this.isEdit ? 'Salvar o produto' : 'Adicionar ao carrinho'}
              </PrimaryButton>
            </Form>
          </div>
        </CartLayout>
        <div slot="fixed">
          <Cart router={this.$f7router} />
        </div>
        <ApplicationModal
          open={this.state.openModal}
          onCloseModal={() => {
            this.setState({ openModal: false })
          }}
          product={selectedProduct?.name}
          existingApplication={this.state.existingApplication}
          newApplication={this.state.newApplication}
          onAbandon={() =>
            this.setState({ openModal: false })
          }
        />
      </Page>
    )
  }
}

const mapStateToProps = state => {
  const selectedProduct = state.cart.selected || state.product.selected
  return {
    selectedPivot: state.cart.selectedPivot || state.pivot.selected,
    selectedProduct,
    selectedFarm: state.farm.selected,
    chemicalResale: state.product.chemicalResales[selectedProduct.id],
    cart: state.cart.cart,
  }
}

const mapDispatchToProps = dispatch => ({
  addToCart: (product, pivot) => dispatch(addToCart(product, pivot)),
  setSelectedProduct: p => dispatch(setSelectedProduct(p)),
  setSelectedPivot: p => dispatch(setSelectedPivot(p)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfigProduct)
